const actions = [
  {
    group: 'general',
    name: 'fieldRotate',
    disabled: false,
  },
  {
    group: 'general',
    name: 'fieldScale',
    disabled: false,
  },
  {
    group: 'general',
    name: 'translateLeftSmall',
    shortcuts: ['shift+left'],
    disabled: false,
  },
  {
    group: 'general',
    name: 'translateRightSmall',
    shortcuts: ['shift+right'],
    disabled: false,
  },
  {
    group: 'general',
    name: 'translateUpSmall',
    shortcuts: ['shift+up'],
    disabled: false,
  },
  {
    group: 'general',
    name: 'translateDownSmall',
    shortcuts: ['shift+down'],
    disabled: false,
  },
  {
    group: 'general',
    name: 'rotateLeftByStep',
    shortcuts: ['alt+left', 'ctrl+left'],
    disabled: false,
  },
  {
    group: 'general',
    name: 'rotateRightByStep',
    shortcuts: ['alt+right', 'ctrl+right'],
    disabled: false,
  },
  {
    group: 'general',
    name: 'translateLeft',
    shortcuts: ['left'],
    disabled: false,
  },
  {
    group: 'general',
    name: 'translateRight',
    shortcuts: ['right'],
    disabled: false,
  },
  {
    group: 'general',
    name: 'translateUp',
    shortcuts: ['up'],
    disabled: false,
  },
  {
    group: 'general',
    name: 'translateDown',
    shortcuts: ['down'],
    disabled: false,
  },
];

export default actions;
